export const AI_MEMORIES_REDUCER_KEY = 'aiMemoriesStore';
export type AI_MEMORIES_REDUCER_KEY = typeof AI_MEMORIES_REDUCER_KEY;

import type { QcsResourceSlice } from 'app-components/flux/core/resourceSliceUtils';
import { v4 as uuidv4 } from 'uuid';
import z from 'zod';

// Define a separate schema for the 'data' object
export const AiMemoriesDataSchema = z
  .object({
    name: z.string(),
    memory: z.string(),
    priority: z.number(),
  })
  .partial();

export type AiMemoriesData = z.infer<typeof AiMemoriesDataSchema>;

// Define RetirementStorageData schema
export const AiMemoriesStorageDataSchema = z
  .object({
    id: z.string(),
    clientId: z.string(),
    createdAt: z.string(),
    modifiedAt: z.string(),
    isDeleted: z.boolean(),
    data: AiMemoriesDataSchema,
  })
  .partial();

export type AiMemoriesStorageData = z.infer<typeof AiMemoriesStorageDataSchema>;

export const aiMemoriesStorageDataDefault: AiMemoriesStorageData = {
  id: undefined,
  clientId: uuidv4().toUpperCase(),
  createdAt: new Date().toISOString(),
  modifiedAt: new Date().toISOString(),
  isDeleted: false,
  data: {
    name: '',
    memory: '',
    priority: 0,
  },
};

// Define the slice state type using QcsResourceSlice
export type AiMemoriesState = QcsResourceSlice<AiMemoriesStorageData>;
